import { config } from '../config';
import { getHeaders } from './getHeaders';

export const declineOpportunities = (
  token: string,
  rooferId: string,
  opportunityId: string,
) =>
  fetch(
    `${config.classificationUrl}/api/v1/roofer/${rooferId}/project/${opportunityId}/decline`,
    {
      method: 'PUT',
      headers: getHeaders(token),
    },
  );
